import clsx from "clsx"
import { CartProductImagePlaceholder } from "src/checkout/components/cartProduct/CartProductImagePlaceholder"
import { ProductListItemImage } from "src/components/product-list/ProductListItemImage"

// https://tailwindcss.com/docs/responsive-design#container-size-reference
export const cartWidthClassName = "w-25 @sm:w-30 @3xl:w-40 shrink-0"
export const cartHeightClassName = "h-25 @sm:h-30 @3xl:h-40"

export type CartProductImagetProps = {
  src: string | undefined
  alt: string
}

export const CartProductImage = ({ src, alt }: CartProductImagetProps) => {
  return (
    <div className={clsx(cartWidthClassName, cartHeightClassName)}>
      {src ? (
        <div className="rounded-2xl bg-white">
          <ProductListItemImage src={src} alt={alt} />
        </div>
      ) : (
        <CartProductImagePlaceholder />
      )}
    </div>
  )
}
